import config from "../../../api_config.json";
import EdgeResizer from "./EdgeResizer";

// Larghezza di default delle thumbnail per le viste a griglia.
const THUMBNAIL_WIDTH = 300;

// Thumbnail via EdgeResizer. L'url dell'allegato può mancare (vedi fix su Giotto),
// e il costruttore di EdgeResizer lancia su url assenti o non validi.
export const getThumbnailUrl = (url, isProd, width = THUMBNAIL_WIDTH) => {
  if (!url) return "";
  try {
    const edgeResizer = new EdgeResizer(config.files[isProd ? "prod" : "dev"], url);
    return edgeResizer.scaleToWidth(width).toString();
  } catch (error) {
    console.error("EdgeResizer error", error);
    return url;
  }
};
